import { useCallback, useEffect, useRef, useState } from 'react'
import { useCourseSettings } from 'src/hooks/useCourseSettings'

/** Key of the course setting that holds the "General"/"Advanced" options. */
export const GENERAL_SETTING_KEY = 'general'

/**
 * The course's `general` setting JSON with auto-save: `save(partial)`
 * merges the change into the latest values and persists it right away.
 */
const useGeneralSettings = () => {
  const { value, exists, execute, update } = useCourseSettings(
    GENERAL_SETTING_KEY,
  )
  const [values, setValues] = useState(value || {})
  // Latest values, so quick consecutive changes don't overwrite each other.
  const latest = useRef(value || {})
  const existsRef = useRef(exists)
  existsRef.current = exists

  useEffect(() => {
    latest.current = value || {}
    setValues(value || {})
  }, [value])

  const save = useCallback(
    partial => {
      const next = { ...latest.current, ...partial }
      latest.current = next
      setValues(next)
      if (existsRef.current) update(next)
      else execute(next)
    },
    [execute, update],
  )

  return [values, save]
}

export default useGeneralSettings
